import { isAxiosError } from "axios";
import { useParams } from "react-router-dom";

import { scheduleCrud } from "@/api/schedule";
import { useFetch } from "@/hooks/common/use-fetch";
import { APIError } from "@/utils";

const getErrorStatus = (error: unknown): number | undefined => {
  if (error instanceof APIError) {
    return error.statusCode;
  }

  if (isAxiosError(error)) {
    return error.response?.status;
  }
};

export const useScheduleDetails = () => {
  const { scheduleId } = useParams<{ scheduleId: string }>();

  const scheduleDetails = useFetch(() => scheduleCrud.getDetail(scheduleId!), {
    queryKey: ["schedule", "detail", scheduleId],
    includeDepartmentInCache: true,
    enabled: Boolean(scheduleId),
  });

  return {
    ...scheduleDetails,
    errorStatus: getErrorStatus(scheduleDetails.error),
  };
};
